<template>
  <div class="card-header is-unselectable">
    <div
      class="program__switch-date card-footer-item is-size-3"
      :class="{ disabled: !previous }"
      @click="goToPrevious"
    >
      <icon name="fa-angle-double-left" />
    </div>
    <div class="program__date card-footer-item">
      <p>{{ dayOfWeek }},</p>
      <p>{{ formattedDate }}</p>
    </div>
    <div
      class="program__switch-date card-footer-item is-size-3"
      :class="{ disabled: !next }"
      @click="goToNext"
    >
      <icon name="fa-angle-double-right" />
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { Icon } from "%helpers";

import { MONTH } from "%utils/date";

export default {
  name: "program-list-header",

  components: {
    Icon
  },

  props: {
    date: dayjs,
    previous: String,
    next: String
  },

  computed: {
    dayOfWeek() {
      return this.date.format("dddd");
    },

    formattedDate() {
      return `${this.date.date()} ${
        MONTH[this.date.month()]
      } ${this.date.year()} r.`;
    }
  },

  methods: {
    goToPrevious() {
      if (this.previous) {
        this.$emit("go-to", this.previous);
      }
    },

    goToNext() {
      if (this.next) {
        this.$emit("go-to", this.next);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.program {
  &__date {
    flex-grow: 3;
    flex-direction: column;
    font-size: 1.3rem;
    text-align: center;

    @include until($small-mobile) {
      font-size: 1rem;
    }
  }

  &__switch-date {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-content: center;
    color: $link;
    cursor: pointer;

    p {
      font-size: 0.8rem;
    }

    &:hover {
      color: $primary;
    }

    &.disabled {
      cursor: not-allowed;
      color: $grey-light;

      &:hover {
        color: $grey-light;
      }
    }
  }
}
</style>
